module.exports = "/_next/static/images/landing-hero-desktop-48793cce26879a582f1317c0754551c7.png";